export default __webpack_public_path__ + "static/media/leftArrowIcon.755621a5.svg";